const daysFromNow = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString();
};

const hoursAgo = (hours) => {
  const date = new Date();
  date.setHours(date.getHours() - hours);
  return date.toISOString();
};

const daysAgo = (days) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date.toISOString();
};

/**
 * Fixture board for Job tracker mock mode and tests.
 * Counts: saved 5 · applied 3 · in_talks 1 · proposal_sent 1 · won 1
 */
export const jobTrackerFixtureEntries = [
  {
    id: 'entry-saved-1',
    stage: 'saved',
    source: 'twine',
    easy_apply: true,
    source_site: null,
    job_id: 1001,
    ari_job_id: null,
    url: 'https://www.twine.net/jobs/senior-motion-designer',
    title: 'Senior motion designer, 6-week launch campaign',
    company: 'Kettle & Co',
    location: 'Remote',
    rate: '$4k–6k',
    skill: 'Motion design',
    user_edited_at: null,
    is_available: true,
    closes_at: null,
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(48),
    stage_changed_at: hoursAgo(48),
    created_at: hoursAgo(48),
    updated_at: hoursAgo(48),
  },
  {
    id: 'entry-saved-2',
    stage: 'saved',
    source: 'ari',
    easy_apply: false,
    source_site: 'LinkedIn',
    job_id: null,
    ari_job_id: 'ari-2002',
    url: 'https://www.linkedin.com/jobs/view/webflow-developer',
    title: 'Webflow developer for marketing site rebuild',
    company: 'Fathom Labs',
    location: 'Remote',
    rate: 'Contract',
    skill: 'Webflow',
    user_edited_at: null,
    is_available: true,
    closes_at: null,
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(36),
    stage_changed_at: hoursAgo(36),
    created_at: hoursAgo(36),
    updated_at: hoursAgo(36),
  },
  {
    id: 'entry-saved-3',
    stage: 'saved',
    source: 'twine',
    easy_apply: true,
    source_site: null,
    job_id: 1003,
    ari_job_id: null,
    url: 'https://www.twine.net/jobs/voiceover-explainer',
    title: 'Voiceover artist for explainer series',
    company: 'Beacon Health',
    location: 'Remote',
    rate: '$800',
    skill: 'Voiceover',
    user_edited_at: null,
    is_available: true,
    closes_at: daysFromNow(3),
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(24),
    stage_changed_at: hoursAgo(24),
    created_at: hoursAgo(24),
    updated_at: hoursAgo(24),
  },
  {
    id: 'entry-saved-4',
    stage: 'saved',
    source: 'manual',
    easy_apply: false,
    source_site: null,
    job_id: null,
    ari_job_id: null,
    url: 'https://example.com/jobs/illustrator-picture-book',
    title: "Illustrator for a children's picture book",
    company: 'Northwind Press',
    location: 'London or remote',
    rate: null,
    skill: 'Illustration',
    user_edited_at: hoursAgo(12),
    is_available: true,
    closes_at: null,
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(20),
    stage_changed_at: hoursAgo(20),
    created_at: hoursAgo(20),
    updated_at: hoursAgo(12),
  },
  {
    id: 'entry-saved-5',
    stage: 'saved',
    source: 'twine',
    easy_apply: true,
    source_site: null,
    job_id: 1005,
    ari_job_id: null,
    url: 'https://www.twine.net/jobs/podcast-editor',
    title: 'Podcast editor, weekly episodes',
    company: 'Meridian Audio',
    location: 'Remote',
    rate: null,
    skill: null,
    user_edited_at: null,
    is_available: false,
    closes_at: null,
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(72),
    stage_changed_at: hoursAgo(72),
    created_at: hoursAgo(72),
    updated_at: hoursAgo(72),
  },
  {
    id: 'entry-applied-1',
    stage: 'applied',
    source: 'twine',
    easy_apply: true,
    source_site: null,
    job_id: 2001,
    ari_job_id: null,
    url: 'https://www.twine.net/jobs/brand-identity-skincare',
    title: 'Brand identity for DTC skincare launch',
    company: 'Halo Botanics',
    location: 'Remote',
    rate: null,
    skill: null,
    user_edited_at: null,
    is_available: true,
    closes_at: null,
    application: {
      id: 501,
      quote: '$2,400',
      url: 'https://www.twine.net/jobs/brand-identity-skincare',
      declined: false,
    },
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(96),
    stage_changed_at: hoursAgo(40),
    created_at: hoursAgo(96),
    updated_at: hoursAgo(40),
  },
  {
    id: 'entry-applied-2',
    stage: 'applied',
    source: 'ari',
    easy_apply: false,
    source_site: 'Indeed',
    job_id: null,
    ari_job_id: 'ari-2003',
    url: 'https://www.indeed.com/viewjob?jk=react-native',
    title: 'React Native contractor, 3 months',
    company: 'Tandem Labs',
    location: 'Remote',
    rate: '$550/day',
    skill: 'React Native',
    user_edited_at: null,
    is_available: true,
    closes_at: null,
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(80),
    stage_changed_at: hoursAgo(30),
    created_at: hoursAgo(80),
    updated_at: hoursAgo(30),
  },
  {
    id: 'entry-applied-3',
    stage: 'applied',
    source: 'twine',
    easy_apply: true,
    source_site: null,
    job_id: 2003,
    ari_job_id: null,
    url: 'https://www.twine.net/jobs/social-content-designer',
    title: 'Social content designer, 3-month retainer',
    company: 'Driftwood Apparel',
    location: 'Remote',
    rate: null,
    skill: null,
    user_edited_at: null,
    is_available: true,
    closes_at: null,
    application: {
      id: 503,
      quote: null,
      url: 'https://www.twine.net/jobs/social-content-designer',
      declined: true,
    },
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(120),
    stage_changed_at: hoursAgo(60),
    created_at: hoursAgo(120),
    updated_at: hoursAgo(60),
  },
  {
    id: 'entry-in-talks-1',
    stage: 'in_talks',
    source: 'ari',
    easy_apply: false,
    source_site: 'Company site',
    job_id: null,
    ari_job_id: 'ari-3001',
    url: 'https://pixelmark.example/careers/ux-designer',
    title: 'UX designer, fintech onboarding flow',
    company: 'Pixelmark',
    location: 'Hybrid, Manchester',
    rate: '$6k fixed',
    skill: null,
    user_edited_at: null,
    is_available: true,
    closes_at: null,
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(200),
    stage_changed_at: hoursAgo(18),
    created_at: hoursAgo(200),
    updated_at: hoursAgo(18),
  },
  {
    id: 'entry-proposal-1',
    stage: 'proposal_sent',
    source: 'manual',
    easy_apply: false,
    source_site: null,
    job_id: null,
    ari_job_id: null,
    url: 'https://example.com/jobs/fractional-cd',
    title: 'Fractional creative director, 2 days a week',
    company: 'Oakline Studio',
    location: 'Remote',
    rate: '$1,100/day',
    skill: null,
    user_edited_at: hoursAgo(8),
    is_available: true,
    closes_at: null,
    application: null,
    hired_on_twine: false,
    client: null,
    saved_at: hoursAgo(150),
    stage_changed_at: hoursAgo(10),
    created_at: hoursAgo(150),
    updated_at: hoursAgo(8),
  },
  {
    id: 'entry-won-1',
    stage: 'won',
    source: 'twine',
    easy_apply: true,
    source_site: null,
    job_id: 4001,
    ari_job_id: null,
    url: 'https://www.twine.net/jobs/explainer-video',
    title: 'Explainer video for product launch',
    company: 'Kettle & Co',
    location: 'Remote',
    rate: '$3,200',
    skill: null,
    user_edited_at: null,
    is_available: true,
    closes_at: null,
    application: {
      id: 601,
      quote: '$3,200',
      url: 'https://www.twine.net/jobs/explainer-video',
      declined: false,
    },
    hired_on_twine: true,
    client: {
      id: 9001,
      message_url: '/messages/kettle-co',
    },
    saved_at: hoursAgo(400),
    stage_changed_at: hoursAgo(5),
    created_at: hoursAgo(400),
    updated_at: hoursAgo(5),
  },
];

export const jobTrackerFixtureCounts = {
  saved: 5,
  applied: 3,
  in_talks: 1,
  proposal_sent: 1,
  won: 1,
};

export const jobTrackerFixturePagination = {
  saved: { has_more: false, next_cursor: null },
  applied: { has_more: false, next_cursor: null },
  in_talks: { has_more: false, next_cursor: null },
  proposal_sent: { has_more: false, next_cursor: null },
  won: { has_more: false, next_cursor: null },
};

export const jobTrackerFixtureBoard = {
  data: jobTrackerFixtureEntries,
  meta: {
    counts: { ...jobTrackerFixtureCounts },
    pagination: { ...jobTrackerFixturePagination },
    per_stage: 10,
  },
};

export const jobTrackerFixtureRecentlyViewed = {
  data: [
    {
      job_id: 3101,
      ari_job_id: null,
      source: 'twine',
      source_site: null,
      title: 'Motion designer for app store trailers',
      company: 'Marlow Games',
      viewed_at: hoursAgo(2),
    },
    {
      job_id: null,
      ari_job_id: 'ari-3102',
      source: 'ari',
      source_site: 'LinkedIn',
      title: 'Brand illustrator for product launch kit',
      company: 'Sable Skincare',
      viewed_at: daysAgo(1),
    },
    {
      job_id: 1001,
      ari_job_id: null,
      source: 'twine',
      source_site: null,
      title: 'Senior motion designer, 6-week launch campaign',
      company: 'Kettle & Co',
      viewed_at: hoursAgo(5),
    },
    {
      job_id: null,
      ari_job_id: 'ari-2002',
      source: 'ari',
      source_site: 'LinkedIn',
      title: 'Webflow developer for marketing site rebuild',
      company: 'Fathom Labs',
      viewed_at: hoursAgo(8),
    },
    {
      job_id: null,
      ari_job_id: 'ari-3105',
      source: 'ari',
      source_site: 'Indeed',
      title: 'Freelance UX writer for onboarding flows',
      company: 'Northwind Apps',
      viewed_at: hoursAgo(20),
    },
    {
      job_id: 3106,
      ari_job_id: null,
      source: 'twine',
      source_site: null,
      title: 'Sound designer for short-form ads',
      company: 'Pulse Audio',
      viewed_at: daysAgo(2),
    },
  ],
};

export const jobTrackerFixtureLinkPreview = {
  fetched: true,
  url: 'https://example.com/jobs/example',
  title: 'Example freelance role',
  company: 'Example Co',
  source_site: 'Company site',
  location: 'Remote',
};
